import Request from '../../common/Request';

class GsuiteAuth {
  isLoggedIn = () => this.get('isLoggedIn') === 'true';

  set = (key, value) => localStorage.setItem(key, value);

  get = key => this.getLocalStorage(key);

  getLocalStorage = key => {
    const ret = localStorage.getItem(key);
    if (ret) {
      return ret;
    }
    return null;
  };

  login = async (token) => {
    // ログイン処理
    // ログインエラー時には、falseを返してもいいし、returnを別の用途で利用したかったら
    // 例外を出しして呼び出し元でcatchしてもいいかと思います。

    this.set('isLoggedIn', true);

    return true;
  };

  logout = async () => {
    if (this.isLoggedIn()) {
      if(this.get('token')) {
        Request.post('/api/logout', {}, (res) => {}, () => {}, () => {});
      }
      this.set('name', '');
      this.set('email', '');
      this.set('picture', '');
      this.set('division_name', '');
      this.set('employee_type', '');
      this.set('token', '');
      this.set('isLoggedIn', false);

      this.set('id', '');
      this.set('is_active', '');
      this.set('is_staff', '');
      this.set('first_name', '');
      this.set('last_name', '');
      this.set('email', '');
      this.set('user_cc_email', '');
      this.set('user_branch_natural_id', '');
      this.set('user_branch_name', '');
      this.set('user_branch_zip_code', '');
      this.set('user_branch_prefecture', '');
      this.set('user_branch_city', '');
      this.set('user_branch_address', '');
      this.set('user_branch_tel', '');
      this.set('user_branch_fax', '');
      this.set('user_branch_deposit_bank_account', '');
      this.set('___JOIN_user_branch_address', '');
      this.set('DATA', ''); 
      this.set('BUTTONS', '');

      // ログアウト処理
      //　他に必要な処理があるのならこちら
      window.location.href = '/login';
    }
  };
}

export default new GsuiteAuth();